/**
 * WooCommerce specific JavaScript
 * This file is the entry point for WooCommerce-specific functionality
 */

import cartEventLinks from './__woocommerce/cartEventLinks';

// Initialize cart event links when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		cartEventLinks.init();
	});
} else {
	// DOM is already loaded
	cartEventLinks.init();
}